import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { getImgPath } from '../../store/JSTool';

export default function GamePosterView() {

    return (
        <Stack sx={{
            width: 1,
            bgcolor: 'black',
        }}>

            <Stack sx={{
                height: '400px',
                justifyContent: 'center',
                flexDirection: 'row',
                pt: 1,
            }}>
                <ImageItem index={0} imgName='works_OPMW.png' />
                <ImageItem index={1} imgName='works_SFD2.png' />
                <ImageItem index={2} imgName='works_MHA.png' />
                <Stack sx={{
                    mx: 1,
                    height: 0.9,
                    borderRadius: '8px',
                    bgcolor: '#FFA129',
                    width: '300px',
                    cursor: 'pointer',
                    color: 'white',
                    justifyContent: 'center',
                    alignItems: 'center',
                    transitionDuration: '0.3s',
                    '&:hover': {
                        transform: 'scale(1.03)',
                    }
                }}>
                    <Typography sx={{
                        fontFamily: 'Lexend Deca',
                        mr: 5,
                        fontSize: 30
                    }}>
                        View
                    </Typography>

                    <Typography sx={{
                        ml: 5,
                        fontFamily: 'Lexend Deca',
                        fontSize: 30
                    }}>
                        More
                    </Typography>
                </Stack>

            </Stack>
        </Stack>
    );
}

function ImageItem(props) {

    function itemTap() {
        if (props.index == 0) {
            window.open('https://eu.onepunchmanworld.com');

        } else if (props.index == 1) {
            window.open('https://www.sfduelmobile.com');

        } else if (props.index == 2) {
            window.open('https://myherotsh.com/');

        }
    }


    return (
        <Box
            onClick={itemTap}
            component={'img'}
            src={getImgPath(props.imgName)}
            sx={{
                height: 0.9,
                mx: 1,
                borderRadius: '8px',
                cursor: 'pointer',
                transitionDuration: '0.3s',
                '&:hover': {
                    transform: 'scale(1.03)',
                }
            }} />
    );
}